export default "__VITE_ASSET__U9rs4xpa__"